import { Alert, Radio, Stack, Typography } from "@mui/material"
import { ReactElement } from "react"

type ResidentialRadioFormProps = {
    isResidential: boolean | null
    setIsResidential: (value: boolean) => void
}

export const ResidentialRadioForm = ({
    isResidential,
    setIsResidential,
}: ResidentialRadioFormProps): ReactElement => (
    <Stack width="100%" direction="column" spacing={1}>
        <Typography variant="body1" color="text.primary">
            Is this an application for a residential property?*
        </Typography>
        <Stack width="100%" direction="row" spacing={2} pl={4}>
            <div>
                Yes
                <Radio
                    checked={isResidential === true}
                    onChange={() => setIsResidential(true)}
                    inputProps={{ "aria-label": "Yes" }}
                />
            </div>
            <div>
                No
                <Radio
                    checked={isResidential === false}
                    onChange={() => setIsResidential(false)}
                    inputProps={{ "aria-label": "No" }}
                />
            </div>
        </Stack>
        {!isResidential && isResidential !== null && (
            <Alert
                severity="error"
                sx={{
                    ml: 3,
                    borderRadius: 2,
                    px: 4,
                    py: 2,
                }}
            >
                <Typography variant="body1" component="span">
                    Connect Direct currently only accepts applications for
                    residential properties. If this is a commercial property
                    application, please contact your relevant DNO to raise an
                    application with them directly.
                </Typography>
            </Alert>
        )}
    </Stack>
)
